import React, { useEffect, useState } from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect } from 'react-redux'
import { getPrimary } from '../../services/languages/index'
import Link, { TARGET_BLANK } from '../Link/index'
import {
  URL_ROKU_APP_STORE,
  URL_ANDROID_APP_STORE,
  URL_APPLE_APP_STORE,
  URL_AMAZON_APP_STORE_FIRE_TV,
  URL_CHROMECAST,
} from '../../services/url/constants'
import { DE } from '../../services/languages/constants'
import { H2 } from '../Heading/index'

function CtaDevices ({ staticText, userLanguage }) {
  const ctaTitle = staticText.getIn(['data', 'watchTitle'])
  const currentLanguage = getPrimary(userLanguage)

  const [imageSRC, setImageSRC] = useState(null)

  useEffect(() => {
    async function loadImage () {
      const { default: src } = await import('./img/new-devices.png')
      setImageSRC(src)
    }
    loadImage()
  })

  return (
    <div className="cta-devices">
      <div className="cta-devices__center">
        <H2 inverted>{ctaTitle}</H2>
        {imageSRC && <img
          className="cta-devices__img"
          alt={ctaTitle}
          src={imageSRC}
        />
        }
        <ul>
          <li>
            <Link
              target={TARGET_BLANK}
              to={URL_APPLE_APP_STORE}
              title={staticText.getIn(['data', 'downloadIOS'])}
              className="cta-devices__link cta-devices__link--appleios"
            />
          </li>
          <li>
            <Link
              target={TARGET_BLANK}
              to={URL_ANDROID_APP_STORE}
              title={staticText.getIn(['data', 'downloadAndroid'])}
              className="cta-devices__link cta-devices__link--android"
            />
          </li>
          <li>
            <Link
              target={TARGET_BLANK}
              to={URL_CHROMECAST}
              title={staticText.getIn(['data', 'downloadChromecast'])}
              className="cta-devices__link cta-devices__link--chromecast"
            />
          </li>
          <li>
            <Link
              target={TARGET_BLANK}
              to={URL_ROKU_APP_STORE}
              title={staticText.getIn(['data', 'downloadRoku'])}
              className="cta-devices__link cta-devices__link--roku"
            />
          </li>
          {currentLanguage !== DE
            && <li>
              <Link
                target={TARGET_BLANK}
                to={URL_AMAZON_APP_STORE_FIRE_TV}
                title={staticText.getIn(['data', 'downloadFire'])}
                className="cta-devices__link cta-devices__link--firetv"
              />
            </li>
          }
        </ul>
      </div>
    </div>
  )
}

CtaDevices.propTypes = {
  staticText: ImmutablePropTypes.map.isRequired,
  userLanguage: ImmutablePropTypes.list.isRequired,
}

export default connect(
  (state) => ({
    staticText: state.staticText.getIn(['data', 'ctaDevices']),
    userLanguage: state.user.getIn(['data', 'language']),
  }),

)(CtaDevices)
